var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2738 15.5758C7.59479 15.6198 7.92316 15.6426 8.25714 15.6426C11.9811 15.6426 15 12.8124 15 9.32115C15 5.82989 11.9811 2.99971 8.25714 2.99971C7.92316 2.99971 7.59479 3.02247 7.2738 3.06644",
    stroke: "#F03B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35705 9.3212H9.38086M2.35705 9.3212C2.35705 9.813 3.75781 10.7319 4.113 11.0771M2.35705 9.3212C2.35705 8.82939 3.75781 7.91046 4.113 7.56524",
    stroke: "#F03B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutRed);
export default __webpack_public_path__ + "static/media/logout-red.6214525c66212bf17fe0a1207afbf7ba.svg";
export { ForwardRef as ReactComponent };